import { AlertMessage, ProgressIndicator } from '../framework/widgets'
import { FetchStatus, PageMode } from '../framework/base/types'

import { MediaImage } from '../framework/design/components'
import { PageTitle } from '../_metronic/layout/core'
import { PageViewer } from '../framework/design/page'
import { useAuth } from '../modules/auth'
import { useDashboardPage } from '../framework/providers'
import { useEffect } from 'react'
import { useLazyGetSiteQuery } from '../framework/services/auth'

export const DashboardWrapper = () => {
  const { page, status, error } = useDashboardPage();

  if (status === FetchStatus.Idle || status === FetchStatus.Loading) {
    return <PageTemplate title='Dashboard'>
      <ProgressIndicator show={true} message="Loading..." />
    </PageTemplate>
  }

  if (!page || status === FetchStatus.Error) {
    return <PageTemplate title='Dashboard'>
      <DefaultDashboard>
        <AlertMessage type='Error' show={status === FetchStatus.Error} message={error} />
      </DefaultDashboard>
    </PageTemplate>
  }

  return (
    <PageTemplate title={page.title || page.name}>
      <PageViewer
        page={page}
        showHeader={false}
        pageView={{ pageMode: PageMode.View }}
        showTitle={true}
        showRefresh={true} />
    </PageTemplate>
  )
}

const PageTemplate = ({ title, children }: {
  title: string
  children?: React.ReactNode
}) => {
  return (
    <div className="position-relative">
      <PageTitle breadcrumbs={[]}>{title}</PageTitle>
      {children}
    </div>
  )
}

const DefaultDashboard = ({ children }: { children?: React.ReactNode }) => {
  const { user, siteId } = useAuth();
  const [getSite, { data: site }] = useLazyGetSiteQuery()

  useEffect(() => {
    if (!siteId) return;

    getSite(siteId);
    // eslint-disable-next-line
  }, [user])

  return <>
    <div className="">
      {site?.logo && <MediaImage className="w-100px" mediaId={site?.logo} />}
      <h2 className='text-gray-600 mt-10'>{site?.title}</h2>
      {site?.description ?
        <p>{site?.description}</p> :
        <p className='text-muted fs-7'>
          No dashboard assigned to your profile. Please contact the support team.
        </p>
      }

      {children}
    </div>
  </>
}
